export default __webpack_public_path__ + "images/assets/fc59dd38043a018f1023370b37a431c1.svg";